import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BookingSummaryItem } from '../../common/items/BookingSummaryItem';

export const BookingSummaryAddress = ({ booking, iosWebView }) => {
  if (!booking?.space?.address) {
    return null;
  }

  return (
    <BookingSummaryItem
      testingId='booking-summary-address'
      label={
        <FormattedMessage
          id='inbox.summary_props.address'
          defaultMessage='Address'
        />
      }
    >
      <>
        <div
          data-testing-id='booking-summary-displayed-address'
          className='hyphenate'
        >
          {booking.space.address}
        </div>
        {!iosWebView && (
          <a
            target='_blank'
            href={`https://maps.google.com/maps?daddr=${encodeURIComponent(
              booking.space.address
            )}`}
          >
            <FormattedMessage
              id='inbox.summary_props.get_directions'
              defaultMessage='Get directions to the space'
            />
          </a>
        )}
      </>
    </BookingSummaryItem>
  );
};

BookingSummaryAddress.propTypes = {
  booking: PropTypes.object.isRequired,
  iosWebViewConfig: PropTypes.shape({
    isWebView: PropTypes.bool
  })
};
